import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  padding: 2em 0;\n  position: relative;\n  display: grid;\n  grid-gap: 10px;\n  grid-template-columns: repeat(4, 1fr);\n\n  @media screen and (max-width: ', ') {\n    grid-template-columns: repeat(3, 1fr);\n  }\n'], ['\n  padding: 2em 0;\n  position: relative;\n  display: grid;\n  grid-gap: 10px;\n  grid-template-columns: repeat(4, 1fr);\n\n  @media screen and (max-width: ', ') {\n    grid-template-columns: repeat(3, 1fr);\n  }\n']);

import styled from 'styled-components';

export var StyledGrid = styled.ul(_templateObject, function (props) {
  return props.theme.tabletWidth;
});